(() => {
  const form = document.querySelector('#PawMagicProductForm');
  if (!form) return;
  const cards = [...form.querySelectorAll('[data-variant-id]')];
  const variantInput = form.querySelector('#PawMagicVariantId');
  const quantityInput = form.querySelector('[name="quantity"]');
  const addButton = form.querySelector('#PawMagicAddButton');
  const quantityControls = [...form.querySelectorAll('[data-quantity-step]')];

  const quantity = () => {
    const value = Number(quantityInput.value);
    return Number.isInteger(value) && value >= 1 && value <= 99 ? value : 1;
  };

  function updateButton() {
    const selected = cards.find((card) => card.getAttribute('aria-checked') === 'true');
    if (!selected) return;
    const count = quantity();
    const units = selected.dataset.pack === 'duo' ? 2 : 1;
    const price = selected.dataset.price;
    addButton.innerHTML = `Add ${count} × ${units}-glove ${count === 1 ? 'pack' : 'packs'} <span>${price} each</span><b aria-hidden="true">→</b>`;
  }

  function choose(card) {
    if (card.disabled) return;
    cards.forEach((candidate) => {
      const active = candidate === card;
      candidate.setAttribute('aria-checked', String(active));
      candidate.classList.toggle('selected', active);
    });
    variantInput.value = card.dataset.variantId;
    updateButton();
  }

  cards.forEach((card, index) => {
    card.addEventListener('click', () => choose(card));
    card.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const direction = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
      for (let offset = 1; offset <= cards.length; offset += 1) {
        const next = cards[(index + direction * offset + cards.length * 2) % cards.length];
        if (!next.disabled) {
          next.focus();
          choose(next);
          break;
        }
      }
    });
  });

  quantityControls.forEach((button) => {
    button.addEventListener('click', () => {
      const next = Math.max(1, Math.min(99, quantity() + Number(button.dataset.quantityStep)));
      quantityInput.value = String(next);
      updateButton();
    });
  });
  quantityInput.addEventListener('input', updateButton);
  quantityInput.addEventListener('blur', () => {
    quantityInput.value = String(quantity());
    updateButton();
  });
  form.addEventListener('submit', (event) => {
    const selected = cards.find((card) => card.getAttribute('aria-checked') === 'true');
    if (!selected || !selected.dataset.variantId || !Number.isInteger(Number(quantityInput.value)) || Number(quantityInput.value) < 1 || Number(quantityInput.value) > 99) {
      event.preventDefault();
      quantityInput.focus();
    }
  });
  updateButton();
})();
